// Lume: phone product gallery dots. Original code (Lume Designs, Oct 2026).
// Reads Dawn's own slider (scroll position of .product__media-list) - it never moves slides itself
// except when a dot is tapped, using the same scrollTo Dawn's arrows use.
(function () {
  function build(list) {
    if (list.dataset.lumeDots) return; list.dataset.lumeDots = '1';
    const slides = [...list.querySelectorAll('.product__media-item')].filter(s => s.offsetParent !== null || getComputedStyle(s).display !== 'none');
    if (slides.length < 2) return;
    const wrap = document.createElement('div'); wrap.className = 'lume-dots'; wrap.setAttribute('role', 'tablist');
    slides.forEach((s, i) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'lume-dots__dot';
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', () => list.scrollTo({ left: s.offsetLeft - list.offsetLeft, behavior: 'smooth' })); wrap.appendChild(b); });
    const host = list.closest('slider-component') || list.parentElement; host.insertAdjacentElement('afterend', wrap);
    const dots = [...wrap.children];
    const sync = () => { let best = 0, d = Infinity; slides.forEach((s, i) => { const x = Math.abs(s.offsetLeft - list.offsetLeft - list.scrollLeft); if (x < d) { d = x; best = i; } });
      dots.forEach((b, i) => b.classList.toggle('is-active', i === best)); };
    list.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true }); sync();
  }
  function init() { if (!window.matchMedia('(max-width: 749px)').matches) return; document.querySelectorAll('.product__media-list.slider--mobile').forEach(build); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

// Lume: keep Afterpay's instalment amount in step with the selected variant (120cm vs 150cm etc.).
(function () {
  function hook() {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant; if (!v) return;
      document.querySelectorAll('square-placement, afterpay-placement').forEach(function (pl) { pl.setAttribute('data-amount', (v.price / 100).toFixed(2)); });
    });
    return true;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
